module.exports = __webpack_public_path__ + "assets/img/explore-selected.cb56fafe.png";